import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const shopLink = {
  cigPoshta:
    'https://cig-poshta.in.ua/parliament-soho-compact-silver/?utm_source=CDAsmsSohoSilver',
  rozetka:
    'https://rozetka.com.ua/ua/parliament-4823003215242/p396796200/?utm_source=PMUsmsSohoSilver'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.packsContainer}>
          <img
            className={styles.headBg}
            src={getImageFromS3('images/25ua-kv3/head-bg.png')}
            alt="head-bg"
          />
          <img
            src={getImageFromS3('images/25ua-kv3/logo.png')}
            alt="headLogo"
            className={styles.headLogo}
          />
          <p className={styles.title}>SOHO NYC</p>
          <p className={styles.subTitle}>Compact Silver</p>
          <img
            src={getImageFromS3('images/sms-soho/headPacks.png')}
            alt="headPacks"
            className={styles.headPacks}
          />
          <p className={styles.disclaimer}>*зазначено задекларовану максимальну роздрібну ціну з урахуванням акцизного податку на роздрібний продаж тютюнових виробів станом на лютий 2026 року</p>
          <p className={styles.formatTitle}><span>20 сигарет</span> у компактному форматі<br /> <span>“King Size” Slims</span></p>
        </div>
        <div className={styles.characteristicContainer}>
          <img
            className={styles.contentBg}
            src={getImageFromS3('images/25ua-kv3/content-bg.png')}
            alt="content-bg"
          />
          <div className={styles.filter}>
            <img
              src={getImageFromS3('images/25ua-kv3/filter.png')}
              alt="filter"
            />
          </div>
          <div className={styles.tobacco}>
            <img
              src={getImageFromS3('images/25ua-kv3/tobacco.png')}
              alt="tobacco"
            />
          </div>
          <div className={styles.qrCode}>
            <img
              src={getImageFromS3('images/sms-soho/qr-code.png')}
              alt="qr-code"
            />
          </div>
          <img
            src={getImageFromS3('images/25ua-kv3/title.png')}
            alt="title"
            className={styles.bottomTitle}
          />
          <p className={styles.subTitle}>
            Доступний у компактному<br></br> та супертонкому форматах
          </p>
        </div>
        <div className={styles.footerContainer}>
          <img
            src={getImageFromS3('images/25ua-kv3/footer-bg.png')}
            alt="footer-bg"
          />
        </div>
        <div className={styles.buyContainer}>
          <img
            src={getImageFromS3('images/25ua-kv3/buy-bg.png')}
            alt="buy-bg"
          />
          <p className={styles.title}>Де купити?</p>
          <p className={styles.description}>
            Актуальний асортимент можна знайти у роздрібних точках продажу в
            твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <button
              onClick={() => {
                sendEvent('rozetka');
                window.open(shopLink.rozetka, '_blank');
              }}
            >
              Rozetka
            </button>
            <button
              onClick={() => {
                sendEvent('сig-poshta');
                window.open(shopLink.cigPoshta, '_blank');
              }}
            >
              Cig-poshta
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння<br /> викликає<br /> серйозні<br /> захворювання та<br /> залежність<br /> Дана інформація<br /> про
        продукт<br /> надається<br /> відповідно<br /> до статті 15<br /> Закону України<br /> «Про захист
        прав<br /> споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав лист, оскільки залишав запит на отримання інформації про
        продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-soho">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
